export default function FacadePage() {
  return (
    <ul>
      <li>Facade: </li>
    </ul>
  );
}
